import styled from 'styled-components';
import CONSTANTS from '../../../Config/Constants';

export const PrintInvoiceWrap = styled.div`
  padding: 20px;
  background: ${CONSTANTS.COLORS.WHITE};
`;
